import React, { useRef, useState } from 'react';

const REVEAL_WIDTH = 84;
const OPEN_THRESHOLD = 40;

export default function SwipeableRow({ children, onDelete }) {
  const [offset, setOffset] = useState(0);
  const [dragging, setDragging] = useState(false);
  const startX = useRef(0);
  const startOffset = useRef(0);
  const active = useRef(false);

  const clamp = (val) => Math.min(0, Math.max(-REVEAL_WIDTH, val));

  const onPointerDown = (e) => {
    active.current = true;
    startX.current = e.clientX;
    startOffset.current = offset;
    setDragging(true);
  };

  const onPointerMove = (e) => {
    if (!active.current) return;
    const delta = e.clientX - startX.current;
    setOffset(clamp(startOffset.current + delta));
  };

  const endDrag = () => {
    if (!active.current) return;
    active.current = false;
    setDragging(false);
    setOffset(prev => (prev <= -OPEN_THRESHOLD ? -REVEAL_WIDTH : 0));
  };

  const handleDeleteClick = () => {
    setOffset(0);
    onDelete();
  };

  return (
    <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '1.25rem' }}>
      <div
        onClick={handleDeleteClick}
        style={{
          position: 'absolute', top: 0, right: 0, height: '100%', width: REVEAL_WIDTH,
          background: '#dc3545', color: '#fff', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', cursor: 'pointer', gap: '2px'
        }}
      >
        <i className="bi bi-trash3-fill" style={{ fontSize: '1.2rem' }} />
        <span style={{ fontSize: '0.68rem', fontWeight: 700 }}>Retirer</span>
      </div>
      <div
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={endDrag}
        onPointerCancel={endDrag}
        onPointerLeave={endDrag}
        style={{
          transform: `translateX(${offset}px)`,
          transition: dragging ? 'none' : 'transform 0.25s ease',
          touchAction: 'pan-y',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          background: '#fff'
        }}
      >
        {children}
      </div>
    </div>
  );
}
